export class RequestUdfModel {
    requestId: number;
    UdfId: number;
    uDFText: string;
    rUDFStep: number;
    rUDFIDisplayOrder: number;
    rUDFTitle: string;
    rUDFValue: string;

    isNew = true;
}
